import { AppRoute } from '@agentselly/immodossier-shared';
import { regionWidgets } from '~/config/widgets/regionWidgets';
import { makeQueryLoaderWidgetsRoute } from '~/helper/makeQueryLoaderWidgetsRoute';

export const Route = makeQueryLoaderWidgetsRoute(
  AppRoute.$LANG_$COMPANYID_$CONTACTID_DOSSIER_$DOSSIERID_REGION,
  regionWidgets,
);
